/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ShippingLocationPage = lazyLoad(
  () => import('./index'),
  module => module.ShippingLocationPage
);
